import './App.css';

import Chat from "./components/chat";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Chat />
      </header>
    </div>
  );
}

export default App;
